//DropdownItem.js
// DropdownItem.jsx
import { forwardRef, useCallback } from "react";
import { Link } from "react-router-dom";

/**
 * Headless DropdownItem
 * - Renders as: button | link (react-router) | a (external)
 * - Keeps menu logic: onSelect, goToMenu/setActiveMenu
 * - Avoids nested interactive elements
 */
const DropdownItem = forwardRef(function DropdownItem(
  {
    // Rendering
    as = "button", // 'button' | 'link' | 'a'
    to, // for as='link'
    href, // for as='a'
    target,
    rel, // for as='a'

    // UI
    className = "",
    leftIcon,
    centerIcon,
    rightIcon,
    disabled = false,
    role = "menuitem", // use 'menuitem' when inside role="menu"

    // Behavior
    onClick, // user handler (can be async)
    onSelect, // recommended: close menu, etc.
    goToMenu,
    setActiveMenu,

    // Content
    children,
    ...rest
  },
  ref
) {
  const Comp = as === "link" ? Link : as === "a" ? "a" : "button";

  const compProps =
    Comp === Link
      ? { to }
      : Comp === "a"
      ? { href, target, rel }
      : { type: "button" };

  const handleClick = useCallback(
    async (e) => {
      if (disabled) {
        e.preventDefault();
        return;
      }

      // 1) Run caller's handler first (respect preventDefault)
      if (typeof onClick === "function") {
        try {
          const r = onClick(e);
          if (r && typeof r.then === "function") await r;
        } catch {
          // swallow to avoid breaking menu behavior
        }
      }

      // 2) Fire onSelect hook (caller can close menu, track analytics, etc.)
      if (!e.defaultPrevented && typeof onSelect === "function") {
        onSelect(e);
      }

      // 3) Built-in submenu navigation (optional)
      if (!e.defaultPrevented && goToMenu && setActiveMenu) {
        setActiveMenu(goToMenu);
      }
    },
    [disabled, onClick, onSelect, goToMenu, setActiveMenu]
  );

  return (
    <Comp
      ref={ref}
      className={className}
      role={role}
      aria-disabled={disabled || undefined}
      onClick={handleClick}
      {...compProps}
      {...rest}
    >
      {leftIcon && (
        <>
          <span className="icon-left">{leftIcon}</span>
          <span className="label">{children}</span>
        </>
      )}
      {centerIcon && (
        <>
          <span className="icon-center">{centerIcon}</span>
        </>
      )}
      {rightIcon && (
        <>
          <span className="label">{children}</span>
          <span className="icon-right">{rightIcon}</span>
        </>
      )}
    </Comp>
  );
});

export default DropdownItem;

// previous
// import React from "react";
// import { Link } from "react-router-dom";

// export const DropdownItem = ({ to, ...props }) => {
//   const {
//     className,
//     leftIcon,
//     rightIcon,
//     children,
//     goToMenu,
//     setActiveMenu,
//     onClick,
//     disabled = false,
//   } = props;
//   const Core = to ? Link : "button";
//   const coreProps = to ? { to } : { type: "button", role: "menuitem" };

//   const handleClick = async (e) => {
//     if (disabled) return;

//     // Run caller's handler first; they can cancel with e.preventDefault()
//     try {
//       if (typeof onClick === "function") {
//         const r = onClick(e);
//         if (r && typeof r.then === "function") {
//           await r; // await async handlers
//         }
//       }
//     } catch {
//       // swallow errors from user handler to avoid breaking menu behavior
//     }

//     // Built-in behavior (only if not canceled)
//     if (!e.defaultPrevented && goToMenu && setActiveMenu) {
//       setActiveMenu(goToMenu);
//     }
//   };

//   return (
//     <Core
//       className={className ? `menu-item ${className}` : "menu-item"}
//       {...coreProps}
//       onClick={handleClick}
//     >
//       {leftIcon && <span className="icon-left">{leftIcon}</span>}
//       {children}
//       {rightIcon && <span className="icon-right">{rightIcon}</span>}{" "}
//     </Core>
//   );
// };

// Previous
// export const DropdownItem = (props) => {
// const {
//   classNames, // keep your existing prop name
//   leftIcon,
//   rightIcon,
//   children,
//   goToMenu,
//   setActiveMenu,
//   onClick, // new: optional
//   disabled = false,
//   ...rest
// } = props;

//   const handleClick = async (e) => {
//     if (disabled) return;

//     // Run caller's handler first; they can cancel with e.preventDefault()
//     try {
//       if (typeof onClick === "function") {
//         const r = onClick(e);
//         if (r && typeof r.then === "function") {
//           await r; // await async handlers
//         }
//       }
//     } catch {
//       // swallow errors from user handler to avoid breaking menu behavior
//     }

//     // Built-in behavior (only if not canceled)
//     if (!e.defaultPrevented && goToMenu && setActiveMenu) {
//       setActiveMenu(goToMenu);
//     }
//   };

//   return (
//     <button
//       type="button"
//       role="menuitem"
//       className={classNames ? `menu-item ${classNames}` : "menu-item"}
//       onClick={handleClick}
//       disabled={disabled}
//       {...rest}
//     >
//       {leftIcon && <span className="icon-left">{leftIcon}</span>}
//       {children}
//       {rightIcon && <span className="icon-right">{rightIcon}</span>}
//     </button>
//   );
// };
